var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedback = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "feedback_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M0 0h22.518v16.865H0z",
  "data-name": "Rectangle 6972"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19625"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19469"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M25-.001a25 25 0 1 1-25 25 25 25 0 0 1 25-25",
  "data-name": "Path 27387"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19470"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#feedback_svg__a)",
  "data-name": "Group 19450",
  transform: "translate(14 16.999)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.375 5.583H.915m6.418 5.183H.915m13.737 5.184H.915m10.216-4.381V9.287l8.1-8.282a.315.315 0 0 1 .445 0l1.839 1.838a.315.315 0 0 1 0 .445l-8.1 8.282Z",
  "data-name": "Path 27321"
}))))));
export { SvgFeedback as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback.6bfc5fb8819778f7dd923b7a0a0d8bc1.svg";